module.exports = __webpack_public_path__ + "img/success-join-icon.0858ec3f.svg";